import * as React from 'react';
import styled from 'styled-components/macro';
import { LoadingIndicator } from 'lib/components';
import { theme } from 'lib/style';
import { Modal } from 'lib/components';
import { MdDeleteForever } from 'react-icons/md';

import { ListWebsiteOverlay } from 'lib/api';
import { Button } from 'react-covideo-common';
import { IoMdClose } from 'react-icons/io';

interface Props {
  onClose: (params?: any) => void;
  onDelete: (params?: any) => void;
  data: ListWebsiteOverlay;
  modalLoading: boolean;
}

interface RowProps {
  justifyContent?: string;
  maxWidth?: string;
}

const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
`;

const Row = styled.section<RowProps>`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: ${props =>
    props.justifyContent ? props.justifyContent : 'flex-start'};
  max-width: ${props => (props.maxWidth ? props.maxWidth : '100%')};
  margin-bottom: 16px;
  &:last-of-type {
    margin-bottom: 0;
  }
  button {
    margin-left: 12px;
  }
`;

const Text = styled.label`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${theme.palette.coal};
  margin: 0;
  padding: 0;
`;

const BoldText = styled(Text)`
  font-weight: 700;
`;

const Title = styled.h2`
  margin: 0;
  padding: 0;

  font-weight: 700;
  font-size: 18px;
  color: ${theme.palette.coal};
`;

const CloseIconWrap = styled.div`
  display: flex;
  height: 24px;
  width: 24px;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;

export const ModalDeleteWebsiteOverlay = (props: Props) => {
  const { data, onClose, onDelete, modalLoading } = props;
  return (
    <Modal>
      <Content>
        {modalLoading && (
          <LoadingIndicator
            isLoading={true}
            color={theme.palette.primaryThemeColor}
            height='100%'
            zIndex={2}
          />
        )}
        <Row justifyContent={'space-between'}>
          <Title>Delete Website Overlay URL?</Title>
          <CloseIconWrap>
            <IoMdClose
              size={24}
              onClick={onClose}
              color={theme.palette.midGrey}
            />
          </CloseIconWrap>
        </Row>
        <Row>
          <Text>
            Are you sure you want to delete the
            <BoldText> '{data.title}' </BoldText>URL?
          </Text>
        </Row>
        <Row>
          <Text>This action can't be undone.</Text>
        </Row>
        <Row justifyContent={'flex-end'}>
          <Button
            icon={<MdDeleteForever />}
            text={'Yes, Delete'}
            onClick={() => onDelete(data.id)}
            variant='destructive'
          />
          <Button text={'No, Keep URL'} onClick={() => onClose()} />
        </Row>
      </Content>
    </Modal>
  );
};
